// eslint-disable-next-line import/prefer-default-export
export function validationSuppression(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('DELETE_FORBIDDEN_IF_REFERENCED_ON_OT') === 0) {
      messages.push({ message: 'listeTypeOt.messages.error.typeOtAlreadyUseOt' });
    }
    if (message.indexOf('DELETE_FORBIDDEN_IF_REFERENCED_ON_DEMANDE') === 0) {
      messages.push({ message: 'listeTypeOt.messages.error.typeOtAlreadyUseDemande' });
    }
  });
}
